// todo: consolidate this form and the one in react-sso-landing
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import { NewFADVPasswordField } from "./fields/NewFADVPasswordField";
import { LoginFormExternalError, NewFADVLoginForm } from "./login/NewFADVLoginForm";
import CognitoPasswordValidator from "./changePasswordForm/CognitoPasswordValidator";
import { changePasswordWatcher } from "../redux/actions/loginactioncreators";
import PropTypes from "prop-types";

export default function ChangePassword() {
  const dispatch = useDispatch();
  const [oldPassword, setOldPassword] = useState("");
  const [passwordReused, setPasswordReused] = useState([true, false]);
  const [passwordsMatch, setPasswordsMatch] = useState([true, false]);
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirm, setNewPasswordConfirm] = useState("");
  const [showErrors, setShowErrors] = useState(false);

  const minPasswordLength = 8;
  const cognitoPasswordValidator = new CognitoPasswordValidator(minPasswordLength, 99, true, true, true, true);

  const handleOnSubmit = (formData, errors) => {
    const { oldPassword, newPassword } = formData;
    if (errors && Object.keys(errors).length > 0) {
      // Do not dispatch if there are errors
      return;
    }

    dispatch(changePasswordWatcher({
      oldPassword: oldPassword,
      newPassword: newPassword
    }));
  }

  const validatePassword = (formData, _errors) => {
    const { oldPassword, newPassword, newPasswordConfirm } = formData;
    setOldPassword(oldPassword);
    setNewPassword(newPassword);
    setNewPasswordConfirm(newPasswordConfirm);
    const passwordsMatchNow = newPassword && newPasswordConfirm && (newPassword === newPasswordConfirm);
    const passwordReusedNow = oldPassword && newPassword && (oldPassword === newPassword);
    setPasswordsMatch(passwordsMatchNow);
    setPasswordReused(passwordReusedNow);
    
    // Show errors if password is reused or passwords don't match and both fields are filled
    if ((passwordReusedNow) || (newPassword && newPasswordConfirm && !passwordsMatchNow)) {
      setShowErrors(true);
    }
  };

  const handleNewPasswordBlur = () => {
    if (newPassword) {
      setShowErrors(true);
    }
  };

  return (
    <NewFADVLoginForm
      onSubmit={handleOnSubmit}
      onChange={validatePassword}
      showErrors={showErrors}
      requiredFields={["oldPassword", "newPassword", "newPasswordConfirm"]}
      headerContent={
        <FormattedMessage
          id="changePassword.changePasswordBlurb"
          defaultMessage="Your password must be changed."
          description="Header text indicating password change is required"
        />
      }
      submitButtonText={
        <FormattedMessage
          id="changePassword.submit"
          defaultMessage="Change password"
          description="Submit button for password change form"
        />
      }
    >
      <LoginFormExternalError id="errorPasswordsDoNotMatch" show={newPassword && newPasswordConfirm && !passwordsMatch} error={
        <FormattedMessage
          id="login.changePasswordPasswordsDoNotMatch"
          defaultMessage="Passwords do not match"
          description="Error message for password field"
        />
      }
      />
      <Typography>
        <FormattedMessage
          id="changePassword.changePasswordInstructions"
          defaultMessage="Enter your current password then choose a new password."
          description="Instructions for changing password"
        />
      </Typography>
      <NewFADVPasswordField
        id="oldPassword"
        name="oldPassword"
        autoFocus={true}
        label={
          <FormattedMessage
            id="changePassword.oldPassword"
            defaultMessage="Current password"
            description="Label for current password field"
          />
        }
      />
      <NewFADVPasswordField
        id="newPassword"
        name="newPassword"
        passwordValidator={cognitoPasswordValidator}
        oldPwd={oldPassword}
        onBlur={handleNewPasswordBlur}
        error={oldPassword && newPassword && passwordReused}
        label={
          <FormattedMessage
            id="changePassword.newPassword"
            defaultMessage="New password"
            description="Label for new password field"
          />
        }
      />
      <NewFADVPasswordField
        id="newPasswordConfirm"
        name="newPasswordConfirm"
        error={newPasswordConfirm && !passwordsMatch}
        label={
          <FormattedMessage
            id="changePassword.verifyPassword"
            defaultMessage="Confirm new password"
            description="Label for password confirmation field"
          />
        }
      />
    </NewFADVLoginForm>
  )
}

ChangePassword.propTypes = {
  onSubmit: PropTypes.func.isRequired,
}